import { getRoutes } from './utils/index.ts'

export const r = {
  routes: getRoutes,
}
